import { inject, Injectable, OnDestroy } from '@angular/core';
import { REMOTE_CONFIG_TOKEN, RemoteConfigProvider } from '@core';
import { VersionDataService } from './version-data.service';
import { VersionConfigData, VersionConfigStorage } from '../storage/version-config.storage';

const SYNC_INTERVAL_MS: number = 60 * 1000;

@Injectable({ providedIn: 'root' })
export class VersionConfigSyncService implements OnDestroy {
  private readonly remoteConfigProvider: RemoteConfigProvider = inject(REMOTE_CONFIG_TOKEN);
  private readonly versionDataService: VersionDataService = inject(VersionDataService);
  private readonly storage: VersionConfigStorage = inject(VersionConfigStorage);
  private intervalId: ReturnType<typeof setInterval> | null = null;

  startSync(): void {
    if (this.intervalId) {
      return;
    }

    this.sync();
    this.intervalId = setInterval(() => this.sync(), SYNC_INTERVAL_MS);
  }

  stopSync(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  async sync(): Promise<void> {
    await this.remoteConfigProvider.fetchAndActivate();
    const config: VersionConfigData | null = await this.versionDataService.fetchConfig();

    if (config) {
      this.storage.setConfig(config.newestVersion, config.availableVersions);
    }
  }

  ngOnDestroy(): void {
    this.stopSync();
  }
}
